var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2023 Félix Robles <felix@sequentech.io>
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { BooleanInput, SelectInput, TextInput, useRefresh, SimpleForm, useGetOne, Toolbar, SaveButton, required, useUpdate, useNotify, RecordContext, } from "react-admin";
import { Accordion, AccordionDetails, AccordionSummary, Tabs, Tab, Grid, IconButton, CircularProgress, } from "@mui/material";
import { useCallback, useContext, useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useMutation } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { CustomTabPanel } from "../../components/CustomTabPanel";
import { IInvalidVotePosition, } from "@sequentech/ui-core";
import { CandidateStyles } from "../../components/styles/CandidateStyles";
import { GET_UPLOAD_URL } from "@/queries/GetUploadUrl";
import { SettingsContext } from "@/providers/SettingsContextProvider";
import { cloneDeep } from "lodash";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import styled from "@emotion/styled";
import { DropFile, Icon, adminTheme } from "@sequentech/ui-essentials";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
import { useGetDocumentUrl } from "@/hooks/useGetDocumentUrl";
var StyledIconButton = styled(IconButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    font-size: 18px;\n    margin-left: auto;\n    margin-right: 8px;\n"], ["\n    color: ", ";\n    font-size: 18px;\n    margin-left: auto;\n    margin-right: 8px;\n"])), adminTheme.palette.brandColor);
export var CandidateDataForm = function (_a) {
    var _b, _c, _d;
    var record = _a.record;
    var t = useTranslation().t;
    var getUploadUrl = useMutation(GET_UPLOAD_URL)[0];
    var _e = useState(["en"]), languageConf = _e[0], setLanguageConf = _e[1];
    var notify = useNotify();
    var refresh = useRefresh();
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _f = useState(true), enabledDeleteImage = _f[0], setEnabledDeleteImage = _f[1];
    var getImageUrl = useGetDocumentUrl();
    var _g = useState(0), value = _g[0], setValue = _g[1];
    var _h = useState("candidate-data-general"), expanded = _h[0], setExpanded = _h[1];
    // const [defaultLangValue, setDefaultLangValue] = useState<string>("")
    var authContext = useContext(AuthContext);
    var canEdit = authContext.isAuthorized(true, authContext.tenantId, IPermissions.CONTEST_WRITE);
    var electionEvent = useGetOne("sequent_backend_election_event", {
        id: record.election_event_id,
        meta: { tenant_id: record.tenant_id },
    }).data;
    var contest = useGetOne("sequent_backend_contest", {
        id: record.contest_id,
        meta: { tenant_id: record.tenant_id },
    }).data;
    var election = useGetOne("sequent_backend_election", {
        id: (_b = contest === null || contest === void 0 ? void 0 : contest.election_id) !== null && _b !== void 0 ? _b : record.tenant_id,
        meta: { tenant_id: record.tenant_id },
    }).data;
    var imageData = useGetOne("sequent_backend_document", {
        id: record.image_document_id,
        meta: { tenant_id: record.tenant_id },
    }).data;
    useEffect(function () {
        var _a, _b;
        if (election) {
            var langConf = (_a = election.presentation) === null || _a === void 0 ? void 0 : _a.language_conf;
            if (langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes) {
                setLanguageConf(langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes);
                return;
            }
        }
        if (electionEvent) {
            var langConf = (_b = electionEvent.presentation) === null || _b === void 0 ? void 0 : _b.language_conf;
            if (langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes) {
                setLanguageConf(langConf === null || langConf === void 0 ? void 0 : langConf.enabled_language_codes);
                return;
            }
        }
    }, [(_c = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _c === void 0 ? void 0 : _c.language_conf, (_d = election === null || election === void 0 ? void 0 : election.presentation) === null || _d === void 0 ? void 0 : _d.language_conf]);
    var updateImage = useUpdate()[0];
    var parseValues = useCallback(function (incoming) {
        var _a;
        if (!electionEvent) {
            return incoming;
        }
        var newCandidate = cloneDeep(incoming);
        newCandidate.type = newCandidate.type || undefined;
        var newPresentation = ((_a = newCandidate.presentation) !== null && _a !== void 0 ? _a : {});
        newCandidate.presentation = newPresentation;
        // name, alias and description fields
        if (!newCandidate.presentation) {
            newCandidate.presentation = { i18n: { en: {} } };
        }
        if (!newCandidate.presentation.i18n) {
            newCandidate.presentation.i18n = { en: {} };
        }
        if (!newCandidate.presentation.i18n.en) {
            newCandidate.presentation.i18n.en = {};
        }
        if (!newCandidate.presentation.i18n.en.name && newCandidate.name) {
            newCandidate.presentation.i18n.en.name = newCandidate.name;
        }
        if (!newCandidate.presentation.i18n.en.alias && newCandidate.alias) {
            newCandidate.presentation.i18n.en.alias = newCandidate.alias;
        }
        if (!newCandidate.presentation.i18n.en.description && newCandidate.description) {
            newCandidate.presentation.i18n.en.description = newCandidate.description;
        }
        newCandidate.name = newCandidate.presentation.i18n.en.name;
        newCandidate.alias = newCandidate.presentation.i18n.en.alias;
        newCandidate.description = newCandidate.presentation.i18n.en.description;
        return newCandidate;
    }, [electionEvent]);
    var invalidVotePositionChoices = function () {
        var choices = Object.values(IInvalidVotePosition).map(function (value) { return ({
            id: value,
            name: t("candidateScreen.invalidVotePosition.".concat(value)),
        }); });
        choices.unshift({ id: "null", name: t("candidateScreen.invalidVotePosition.null") });
        return choices;
    };
    var handleChange = function (event, newValue) {
        setValue(newValue);
    };
    var formValidator = function (values) {
        var _a, _b;
        var errors = { dates: {} };
        if (((_a = values === null || values === void 0 ? void 0 : values.dates) === null || _a === void 0 ? void 0 : _a.end_date) <= ((_b = values === null || values === void 0 ? void 0 : values.dates) === null || _b === void 0 ? void 0 : _b.start_date)) {
            errors.dates.end_date = t("electionEventScreen.error.endDate");
        }
        return errors;
    };
    var renderTabs = function () {
        var tabNodes = [];
        languageConf.forEach(function (lang) {
            tabNodes.push(_jsx(Tab, { label: t("common.language.".concat(lang)), id: lang }, lang));
        });
        // reset actived tab to first tab if only one
        if (tabNodes.length === 1) {
            setValue(0);
        }
        return tabNodes;
    };
    var filterString = function (input) { return input.replace(/[^a-zA-Z0-9-.]/g, ""); };
    var addUrlToPresentation = function (newCandidate, imageDocumentId, name) {
        var _a, _b;
        var imgUrlBase = getImageUrl(newCandidate === null || newCandidate === void 0 ? void 0 : newCandidate.tenant_id, imageDocumentId, name);
        var imgUrl = {
            url: imgUrlBase,
            is_image: true,
        };
        var presentation = cloneDeep((_a = newCandidate.presentation) !== null && _a !== void 0 ? _a : {});
        var urls = (_b = presentation.urls) !== null && _b !== void 0 ? _b : [];
        urls = urls.filter(function (url) { return !url.is_image; });
        urls.push(imgUrl);
        presentation.urls = urls;
        return presentation;
    };
    var removeUrlFromPresentation = function (newCandidate) {
        var _a, _b;
        var presentation = cloneDeep((_a = newCandidate.presentation) !== null && _a !== void 0 ? _a : {});
        var urls = (_b = presentation.urls) !== null && _b !== void 0 ? _b : [];
        urls = urls.filter(function (url) { return !url.is_image; });
        presentation.urls = urls;
        return presentation;
    };
    var handleFiles = function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var theFile, name_1, _a, data, errors, presentation, e_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    theFile = files === null || files === void 0 ? void 0 : files[0];
                    if (!theFile) return [3 /*break*/, 7];
                    name_1 = filterString(theFile.name);
                    return [4 /*yield*/, getUploadUrl({
                            variables: {
                                name: name_1,
                                media_type: theFile.type,
                                size: theFile.size,
                            },
                        })];
                case 1:
                    _a = _c.sent(), data = _a.data, errors = _a.errors;
                    if (!((_b = data === null || data === void 0 ? void 0 : data.get_upload_url) === null || _b === void 0 ? void 0 : _b.document_id)) return [3 /*break*/, 6];
                    _c.label = 2;
                case 2:
                    _c.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, fetch(data.get_upload_url.url, {
                            method: "PUT",
                            headers: {
                                "Content-Type": "image/*",
                            },
                            body: theFile,
                        })];
                case 3:
                    _c.sent();
                    notify(t("electionScreen.common.fileLoaded"), { type: "success" });
                    presentation = addUrlToPresentation(record, data.get_upload_url.document_id, name_1);
                    updateImage("sequent_backend_candidate", {
                        id: record.id,
                        data: {
                            image_document_id: data.get_upload_url.document_id,
                            presentation: presentation,
                        },
                    });
                    refresh();
                    return [3 /*break*/, 5];
                case 4:
                    e_1 = _c.sent();
                    console.log("error :>> ", e_1);
                    notify(t("electionScreen.error.fileError"), { type: "error" });
                    return [3 /*break*/, 5];
                case 5: return [3 /*break*/, 7];
                case 6:
                    console.log("error :>> ", errors);
                    notify(t("electionScreen.error.fileError"), { type: "error" });
                    _c.label = 7;
                case 7: return [2 /*return*/];
            }
        });
    }); };
    var removeImage = function () {
        try {
            setEnabledDeleteImage(false);
            var presentation = removeUrlFromPresentation(record);
            updateImage("sequent_backend_candidate", {
                id: record.id,
                data: {
                    image_document_id: null,
                    presentation: presentation,
                },
            });
            setEnabledDeleteImage(true);
            refresh();
        }
        catch (e) {
            console.log("error :>> ", e);
            notify(t("electionScreen.error.fileError"), { type: "error" });
            setEnabledDeleteImage(true);
        }
    };
    var renderTabContent = function () {
        var tabNodes = [];
        var index = 0;
        languageConf.forEach(function (lang) {
            tabNodes.push(_jsx(CustomTabPanel, __assign({ value: value, index: index }, { children: _jsxs("div", __assign({ style: { marginTop: "16px" } }, { children: [_jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].name"), label: t("electionEventScreen.field.name") }), _jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].alias"), label: t("electionEventScreen.field.alias") }), _jsx(TextInput, { source: "presentation.i18n[".concat(lang, "].description"), label: t("electionEventScreen.field.description") }), _jsx(BooleanInput, { source: "presentation.is_disabled", label: t("candidateScreen.edit.isDisabled") })] })) }), lang));
            index++;
        });
        return tabNodes;
    };
    var DeleteImage = function () { return (_jsxs(StyledIconButton, __assign({ onClick: removeImage, disabled: !enabledDeleteImage }, { children: [!enabledDeleteImage ? (_jsx(CircularProgress, { size: "18px", style: { marginRight: "6px" } })) : null, _jsx(Icon, { variant: "info", icon: faTrash, fontSize: "18px" })] }))); };
    return electionEvent ? (_jsx(RecordContext.Consumer, { children: function (incoming) {
            var parsedValue = parseValues(incoming);
            var imageUrl = getImageUrl(parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.tenant_id, parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id, imageData === null || imageData === void 0 ? void 0 : imageData.name);
            return (_jsxs(SimpleForm, __assign({ validate: formValidator, record: parsedValue, toolbar: _jsx(Toolbar, { children: canEdit && _jsx(SaveButton, {}) }) }, { children: [_jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "candidate-data-general", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "candidate-data-general"
                                    ? ""
                                    : "candidate-data-general";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "candidate-data-general" }) }, { children: _jsx(CandidateStyles.Wrapper, { children: _jsx(CandidateStyles.Title, { children: t("candidateScreen.edit.general") }) }) })), _jsxs(AccordionDetails, { children: [_jsx(Tabs, __assign({ value: value, onChange: handleChange }, { children: renderTabs() })), renderTabContent()] })] })), _jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "candidate-data-type", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "candidate-data-type" ? "" : "candidate-data-type";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "candidate-data-type" }) }, { children: _jsx(CandidateStyles.Wrapper, { children: _jsx(CandidateStyles.Title, { children: t("candidateScreen.edit.type") }) }) })), _jsxs(AccordionDetails, { children: [_jsx(TextInput, { source: "type", label: t("candidateScreen.edit.type") }), _jsx(TextInput, { source: "presentation.subtype", label: "Subtype" }), _jsx(BooleanInput, { source: "presentation.is_explicit_invalid", label: t("candidateScreen.edit.isExplicitInvalid") }), _jsx(BooleanInput, { source: "presentation.is_explicit_blank", label: t("candidateScreen.edit.isExplicitBlank") }), _jsx(BooleanInput, { source: "presentation.is_category_list", label: t("candidateScreen.edit.isCategoryList") }), _jsx(BooleanInput, { source: "presentation.is_write_in", label: t("candidateScreen.edit.isWriteIn") }), _jsx(SelectInput, { source: "presentation.invalid_vote_position", choices: invalidVotePositionChoices(), format: function (value) { return (typeof value == "string" ? value : "null"); }, parse: function (value) { return (value == "null" ? null : value); }, label: t("candidateScreen.invalidVotePosition.label"), emptyValue: t("candidateScreen.invalidVotePosition.null"), defaultValue: null, validate: required() })] })] })), _jsxs(Accordion, __assign({ sx: { width: "100%" }, expanded: expanded === "election-data-image", onChange: function () {
                            return setExpanded(function (prev) {
                                return prev === "election-data-image" ? "" : "election-data-image";
                            });
                        } }, { children: [_jsx(AccordionSummary, __assign({ expandIcon: _jsx(ExpandMoreIcon, { id: "election-data-image" }) }, { children: _jsx(CandidateStyles.Wrapper, __assign({ style: { width: "100%", flexDirection: "row" } }, { children: _jsxs(_Fragment, { children: [_jsx(CandidateStyles.Title, { children: t("electionScreen.edit.image") }), (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) ? _jsx(DeleteImage, {}) : null] }) })) })), _jsx(AccordionDetails, { children: _jsxs(Grid, __assign({ container: true, spacing: 1 }, { children: [_jsx(Grid, __assign({ item: true, xs: 2 }, { children: (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) &&
                                                (parsedValue === null || parsedValue === void 0 ? void 0 : parsedValue.image_document_id) !== "" ? (_jsx("img", { width: 200, height: 200, src: "".concat(globalSettings.PUBLIC_BUCKET_URL).concat(imageUrl), alt: imageUrl })) : null })), _jsx(Grid, __assign({ item: true, xs: 10 }, { children: _jsx(DropFile, { handleFiles: function (files) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                                                    return [2 /*return*/, handleFiles(files)];
                                                }); }); } }) }))] })) })] }))] })));
        } })) : null;
};
var templateObject_1;
